export const useStocksEstimate = ({
  quantity,
  limitPrice,
} : {
  quantity: number | null,
  limitPrice: number | null,
}) => {
  if (!quantity || !limitPrice) {
    return null;
  }
  return quantity * limitPrice;
}